/**
 * M5 가족장 광고그룹 유입 판별.
 *
 * 네이버 SA `후불제_무빈소캠페인_v2` > `M5 가족장·2일장` 그룹. 가족장 A/B 는 이 그룹 안의
 * 소재 두 개(A 무빈소 문구 → 현행 퍼널 / B 가족장 문구 → 가족장 첫 화면)로 나눈다(PR #2728).
 *
 * 비교군인 A 소재도 현행 퍼널을 봐야 해서, 무빈소 Hackle 실험(352 관심 장례식장, E4 절차 개편)
 * 배정은 소재가 아니라 이 광고그룹 단위로 뺀다. 소재를 새로 만들어도 그룹 ID 는 그대로다.
 *
 * n_ad_group 은 네이버 자동 추적이 URL 에 붙인다(`sangjoLandingExperiment.ts` 와 같은 방식).
 */

const FAMILY_AD_GROUP_ID = "grp-a001-01-000000074863806";

/**
 * @param nAdGroup - router.query.n_ad_group (string | string[] | undefined)
 * @returns M5 가족장 광고그룹 유입이면 true
 */
export const isFamilyAdGroup = (nAdGroup: string | string[] | undefined): boolean =>
  typeof nAdGroup === "string" && nAdGroup === FAMILY_AD_GROUP_ID;
